import script from "./lh-feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./lh-feedback.vue?vue&type=script&setup=true&lang=js"

import "./lh-feedback.vue?vue&type=style&index=0&id=43347f24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43347f24"]])

export default __exports__